<div *kienePermission="[1891]">
    <kiene-kiene-table [attr.data-cy]="'mtw_kiene_table'" [tableDescriptor]="tableDescriptor"></kiene-kiene-table>
</div>
